import React, { Component } from 'react'
//import Chart from "chart.js";     // v2.8
import Chart from 'chart.js/auto';  // v3.5
import './chart.css'

let myLineChart;
Chart.defaults.font.size = 12;
Chart.defaults.font.weight = 'bold';
//Chart.defaults.font.family = 'sans-serif';   
// "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"       
const options = {
  //layout: {padding: {bottom:20}},
  legend: { display: false },
  responsive: true,
  maintainAspectRatio: false,     // true is default equals "aspectRatio:2"
  //aspectRatio:2,
  plugins: {
    title: {
      display: true,
      text: 'My Latest Scores'
    }
  },
  scales: {
    x: {
      display: true,
      //padding: {top:40},                    
      title: {
        //color: "purple", // not 'fontColor:' v2.x
        //font: { size: 18},  // 'size' now within object 'font {}'
        //family: "Helvetica", 
        display: true,
        text: [`testID`],
      },

    },

    y: {
      min: 0, max: 100,
      display: true,
      title: {
        display: true,
        text: 'Score'
      }
    }
  }
};

const data = {
  //labels: [],
  datasets: [
    {
      label: "currentScore",
      //data: [],
      fill: false,
      borderColor: "blue"
    },
    {
      label: "averageScore",
      //data: [],
      fill: false,
      borderColor: "purple"
    },
    {
      label: "maxScore",
      //data: [],
      fill: false,
      borderColor: "green"
    },
    {
      label: "minScore",
      //data: [],
      fill: false,
      borderColor: "red"
    }
  ]
};

//--Chart Style Options--//
//Chart.defaults.global.defaultFontFamily = "'PT Sans', sans-serif"
//Chart.defaults.global.legend.display = false;
//--Chart Style Options--//

export default class LineChart extends Component {
  chartRef = React.createRef();

  componentDidMount() {
    this.buildChart();
  }

  componentDidUpdate() {
    this.buildChart();
  }

  buildChart = () => {
    const ctx = this.chartRef.current.getContext("2d");
    const { labels, cScores, aScores, maxScores, minScores } = this.props;

    // update all data
    //options.scales.x.title.text = [`testIDx`, "", "x="+v1]; // p2
    data.labels = labels;
    //labels.push(111); data.labels = labels;
    data.datasets[0].data = cScores; data.datasets[1].data = aScores;
    data.datasets[2].data = maxScores; data.datasets[3].data = minScores;

    if (typeof myLineChart !== "undefined") myLineChart.destroy();

    myLineChart = new Chart(ctx, {
      type: "line",
      data: data,
      options: options,
    });
  }


  render() {
    return (
      <div className="chart-container">
        <canvas id="myChart" ref={this.chartRef} />
      </div>
    )
  }
}